import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';

export interface Category {
    _id: string;
    name: string;
    slug: string;
    parent?: { _id: string; name: string; slug: string } | null;
    description?: string;
    canonicalUrl?: string;
    keyword?: string;
    seoTitle?: string;
    seoDescription?: string;
    level: number;
    isDelete?: boolean;
    createdAt?: string;
    updatedAt?: string;
}

export interface CreateCategoryDto {
    name: string;
    slug: string;
    parent?: string;
    description?: string;
    canonicalUrl?: string;
    keyword?: string;
    seoTitle?: string;
    seoDescription?: string;
}

export interface UpdateCategoryDto extends Partial<CreateCategoryDto> { }

export interface GetPaginationCategoriesDto {
    page?: number;
    limit?: number;
    search?: string;
    level?: number;
    parent?: string;
}

const CATEGORY_ENDPOINTS = {
    CATEGORIES: '/categories',
    HIERARCHICAL: '/categories/hierarchical',
    ROOTS: '/categories/roots',
    TREE: '/categories/tree',
    BY_SLUG: (slug: string) => `/categories/slug/${slug}`,
    BY_ID: (id: string) => `/categories/${id}`,
};

export const categoryService = {
    create(data: CreateCategoryDto): Promise<ApiResponse<any>> {
        return apiClient.post(CATEGORY_ENDPOINTS.CATEGORIES, data);
    },
    findAll(query: GetPaginationCategoriesDto): Promise<ApiResponse<any>> {
        return apiClient.get(CATEGORY_ENDPOINTS.CATEGORIES, query);
    },
    findAllHierarchical(query: GetPaginationCategoriesDto): Promise<ApiResponse<any>> {
        return apiClient.get(CATEGORY_ENDPOINTS.HIERARCHICAL, query);
    },
    findRoots(query: GetPaginationCategoriesDto): Promise<ApiResponse<any>> {
        return apiClient.get(CATEGORY_ENDPOINTS.ROOTS, query);
    },
    getTree(): Promise<ApiResponse<any>> {
        return apiClient.get(CATEGORY_ENDPOINTS.TREE);
    },
    findBySlug(slug: string): Promise<ApiResponse<any>> {
        return apiClient.get(CATEGORY_ENDPOINTS.BY_SLUG(slug));
    },
    findOne(id: string): Promise<ApiResponse<any>> {
        return apiClient.get(CATEGORY_ENDPOINTS.BY_ID(id));
    },
    update(id: string, data: UpdateCategoryDto): Promise<ApiResponse<any>> {
        return apiClient.put(CATEGORY_ENDPOINTS.BY_ID(id), data);
    },
    remove(id: string): Promise<ApiResponse<any>> {
        return apiClient.delete(CATEGORY_ENDPOINTS.BY_ID(id));
    },
};
